var MAX = 50;
var checkScrollSpeed = (function (settings) {
  settings = settings || {};

  var lastPos, newPos, timer, delta,
    delay = settings.delay || 50; 

  function clear() {
    lastPos = null;
    delta = 0;
  }

  clear();

  return function () {
    newPos = window.scrollY;
    if (lastPos != null) { 
      delta = newPos - lastPos;
    }
    lastPos = newPos;
    clearTimeout(timer);
    timer = setTimeout(clear, delay);
    return delta;
  };
})();

var $elements = $('.project-single__img');

var setSkew = _.throttle(function (skew) {
  $elements.css('transform', 'skewY(' + skew + 'deg)')
}, 16);
var setBack = _.debounce(function () {
  $elements.css('transform', 'skewY(0deg)');
}, 100);

$(window).on('scroll', function () {
  var speed = checkScrollSpeed();
  if (speed > MAX) speed = MAX;
  if (speed < -MAX) speed = -MAX;

  setSkew(speed / 15);
  setBack();  
})